if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super()

        this.form = this.querySelector('form')

        this.variantIdInput.disabled = false
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
        this.cart =
          document.querySelector('cart-notification') || document.querySelector('cart-drawer')
        this.submitButton = this.querySelector('[type="submit"]')
        this.submitButtonText = this.submitButton.querySelector('span')

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog')
        }

        this.hideErrors = this.dataset.hideErrors === 'true'
      }

      onSubmitHandler(evt) {
        evt.preventDefault()
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return

        this.handleErrorMessage()

        this.submitButton.setAttribute('aria-disabled', true)
        this.submitButton.classList.add('loading')
        this.querySelector('.loading__spinner').classList.remove('hidden')

        const config = fetchConfig('javascript')
        config.headers['X-Requested-With'] = 'XMLHttpRequest'
        delete config.headers['Content-Type']

        const formData = new FormData(this.form)

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id),
          )
          this.cart.setActiveElement(document.activeElement)
        }

        config.body = formData

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              })

              this.handleErrorMessage(response.description)

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message')
              if (!soldOutMessage) return

              this.submitButton.setAttribute('aria-disabled', true)
              this.submitButtonText.classList.add('hidden')
              soldOutMessage.classList.remove('hidden')
              this.error = true
              return
            } else if (!this.cart) {
              window.location = window.routes.cart_url
              return
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              })
            }

            this.error = false

            const quickAddModal = this.closest('quick-add-modal')

            const renderAndSync = () => {
              this.cart.renderContents(response)

              this.syncGiftsAfterAdd(response).then((updated) => {
                if (updated) this.cart.renderContents(updated)
              })
            }

            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => setTimeout(renderAndSync, 0),
                { once: true },
              )
              quickAddModal.hide(true)
            } else {
              renderAndSync()
            }
          })
          .catch((e) => console.error(e))
          .finally(() => {
            this.submitButton.classList.remove('loading')
            if (this.cart && this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty')
            }
            if (!this.error) this.submitButton.removeAttribute('aria-disabled')
            this.querySelector('.loading__spinner').classList.add('hidden')
          })
      }

      async syncGiftsAfterAdd(cart) {
        const GIFT_75 = '42618513326273'
        const GIFT_125 = '49465770737857'

        const items = cart?.items || []

        const paidTotalCents = items.reduce((sum, it) => {
          const isGift =
            String(it.variant_id) === String(GIFT_75) || String(it.variant_id) === String(GIFT_125)
          return isGift ? sum : sum + (it.final_line_price || 0)
        }, 0)

        const want75 = paidTotalCents >= 7500 ? 1 : 0
        const want125 = paidTotalCents >= 12500 ? 1 : 0

        const has75 = items.some((i) => String(i.variant_id) === String(GIFT_75))
        const has125 = items.some((i) => String(i.variant_id) === String(GIFT_125))

        const changed =
          (!has75 && want75) ||
          (!has125 && want125) ||
          (has75 && !want75) ||
          (has125 && !want125)

        if (!changed) return null

        const updates = {}
        if (has75) updates[GIFT_75] = want75
        else if (want75) updates[GIFT_75] = 1

        if (has125) updates[GIFT_125] = want125
        else if (want125) updates[GIFT_125] = 1

        const body = JSON.stringify({
          updates,
          sections: this.cart.getSectionsToRender().map((s) => s.id),
        })

        const res = await fetch(`${routes.cart_update_url}`, {
          ...fetchConfig(),
          headers: {
            ...(fetchConfig().headers || {}),
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'X-Gift-Sync': '1',
          },
          body,
        })

        const data = await res.json()
        return res.ok ? data : null
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper')
        if (!this.errorMessageWrapper) return

        this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message')

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage)

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled')
          if (text) this.submitButtonText.textContent = text
        } else {
          this.submitButton.removeAttribute('disabled')
          this.submitButtonText.innerHTML = window.variantStrings.addToCart
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]')
      }
    },
  )
}